import { useCallback } from "react";
import { useBackToShoppingUrl } from "~/hooks/use-back-to-shopping-url.hook";
import { VENDOR_PARAMS } from "~/utils/vendor";

/**
 * Where checkout exit links land. Starts from the persisted products URL to
 * keep filters/search context, but drops the vendor and delivery-method
 * params and pins the pathname to /products: the cart may have changed while
 * checkout was open (e.g. delivery method switched in the cart drawer after
 * the URL was captured), so the products loader must restore vendor and
 * delivery method from the cart cookie instead of a stale URL snapshot.
 */
export function useCheckoutExitUrl(): () => string {
	const getBackToShoppingUrl = useBackToShoppingUrl();

	return useCallback(() => {
		const [, search = ""] = getBackToShoppingUrl().split("?");
		const params = new URLSearchParams(search);
		params.delete(VENDOR_PARAMS.vendorId);
		params.delete(VENDOR_PARAMS.deliveryMethod);
		const remaining = params.toString();
		return remaining ? `/products?${remaining}` : "/products";
	}, [getBackToShoppingUrl]);
}
